const W = (id) =>
  `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600`;

// Slide 1 is the signature "3 technicians from behind + BIONET logo" image,
// to be generated externally and dropped at /team-bionet.jpg. Until then it
// 404s and the Hero's onError hides it, so the crossfade continues on the rest.
export const HERO_SLIDES = [
  "/team-bionet.jpg",
  W("photo-1581578731548-c64695cc6952"),
  W("photo-1527515637462-cff94eecc1ac"),
  W("photo-1497366216548-37526070297c"),
];
